module.exports = __webpack_public_path__ + "static/media/02.5f4a478e.png";